const Brand = () => {
  const brands = [
    { name: "Uber", logo: "/mastermind/obn1.svg" },
    { name: "Shiprocket", logo: "/mastermind/obn2.svg" },
    { name: "Domino's", logo: "/mastermind/obn3.svg" },
    { name: "Aditya Birla Group", logo: "/mastermind/obn4.svg" },
    { name: "Shell", logo: "/mastermind/obn5.svg" },
    { name: "Tata Communications", logo: "/mastermind/obn6.svg" },
    { name: "Fresenius Medical Care", logo: "/mastermind/obn7.svg" },
  ];

  return (
    <div
      className="w-full bg-[#08090A] font-fira-sans"
      style={{
        borderBottom: "1px solid rgba(255,255,255,0.20)",
        borderTop: "1px solid rgba(255,255,255,0.20)",
      }}
    >
      {/* 153px CONTAINER WITH LEFT & RIGHT BORDERS */}
      <div
        className="w-[90%] md:w-auto mx-auto md:mx-[153px] py-10 sm:py-20"
        style={{
          borderLeft: "1px solid rgba(255,255,255,0.20)",
          borderRight: "1px solid rgba(255,255,255,0.20)",
        }}
      >
        {/* 60px INNER GAP */}
        <div className="md:px-[60px] px-[16px]">
          <div className="w-full">
            <div className="mb-8">
              <h3 className="text-sm font-medium text-white">
                PAST CORPORATE TRAININGS
              </h3>
              <h2 className="text-2xl sm:text-3xl text-white font-medium mt-2">
                100+ Professionals trained from brands like
              </h2>
            </div>

            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-7 gap-4">
              {brands.map((brand, index) => (
                <img
                  key={index}
                  src={brand.logo}
                  alt={brand.name}
                  className="w-full h-full md:h-[104px] object-contain "
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Brand;
